(() => {

  document.querySelectorAll('.scroll-wrapper').forEach(c => {

    const track = c.nextElementSibling?.classList.contains('custom-scrollbar')
      ? c.nextElementSibling
      : null;

    const thumb = track?.querySelector('span');

    if (!track || !thumb) return;

    let isDragging = false;
    let startX = 0;
    let startScroll = 0;

    const update = () => {

      const maxScroll = c.scrollWidth - c.clientWidth;
      const trackW = track.clientWidth;

      // hide scrollbar if no overflow
      if (maxScroll <= 0) {
        track.style.display = 'none';
        return;
      } else {
        track.style.display = 'block';
      }

      const thumbW = Math.max(
        (c.clientWidth / c.scrollWidth) * trackW * 0.6,
        24
      );

      const x =
        (c.scrollLeft / maxScroll) * (trackW - thumbW);

      thumb.style.width = thumbW + 'px';
      thumb.style.transform = `translateX(${x}px)`;
    };

    // Track click
    track.addEventListener('click', e => {

      if (e.target === thumb) return;

      const r = track.getBoundingClientRect();

      c.scrollLeft =
        ((e.clientX - r.left) / r.width) *
        (c.scrollWidth - c.clientWidth);

    });

    // Drag start
    thumb.addEventListener('mousedown', e => {

      isDragging = true;

      startX = e.clientX;
      startScroll = c.scrollLeft;

      document.body.style.userSelect = 'none';

    });

    // Drag move
    window.addEventListener('mousemove', e => {

      if (!isDragging) return;

      const maxScroll = c.scrollWidth - c.clientWidth;
      const trackW = track.clientWidth;
      const thumbW = thumb.offsetWidth;

      const deltaX = e.clientX - startX;

      const scrollMove =
        (deltaX / (trackW - thumbW)) * maxScroll;

      c.scrollLeft = startScroll + scrollMove;

    });

    // Drag end
    window.addEventListener('mouseup', () => {

      isDragging = false;
      document.body.style.userSelect = '';

    });

    c.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    update();

  });

})();

function updateWhatmoreTitle() {

  document.querySelectorAll(
    '.whatmore-carousel-events > div:first-child > p:not(.wht-prod-info p)'
  ).forEach(el => {

    if (el.dataset.done) return;

    let text = el.textContent.trim();
    let words = text.split(' ');

    if (words.length < 2) return;

    let lastWords = words.splice(-2).join(' ');

    el.innerHTML = `
      ${words.join(' ')}
      <span class="bold-text headline-whatmore">${lastWords}</span>
    `;

    el.dataset.done = 'true';
  });

  // Add class to price container
  document.querySelectorAll('.wht-prod-info').forEach(wrapper => {

    const priceDiv = wrapper.querySelector('div[style*="justify-content"]');

    if (priceDiv && !priceDiv.classList.contains('price-wrapper')) {
      priceDiv.classList.add('price-wrapper');
      console.log('price-wrapper added');
    }

  });
}

const observer = new MutationObserver(() => {
  updateWhatmoreTitle();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

updateWhatmoreTitle();
